import {isFunction} from './isFunction';
import {isStringLiteral} from './isStringLiteral';


export function ucFirst(string: string): string {
	// eslint-disable-next-line
	if (!isStringLiteral(string) || !isFunction(string.charAt)) {
		return string;
	}
	return `${
		string.charAt(0).toUpperCase()
	}${
		string.substring(1, string.length)
	}`;
}
